import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { GroupMatchEntry } from './group-match-entry';
export { GroupMatchEntry };
import { groupMatchEntrySchema } from '@schemas/business-objects/group-match-entry';
import { GroupMatchFormGroup } from './group-match-form-group';
import { MatchFormGroup } from './match-form-group';

export class GroupMatchEntryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    groupMatchId: SchemaFormControl;
    groupMatch: GroupMatchFormGroup;
    matchId: SchemaFormControl;
    match: MatchFormGroup;
  };

  declare value: Partial<GroupMatchEntry>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(groupMatchEntrySchema, GroupMatchEntry, data, options);
  }

  get object(): GroupMatchEntry {
    return new GroupMatchEntry(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'groupMatch':
        return new GroupMatchFormGroup();
      case 'match':
        return new MatchFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<GroupMatchEntry[]> {
    return GroupMatchEntry.find(filter);
  }

  static async findOne(filter?: any): Promise<GroupMatchEntry | null> {
    return GroupMatchEntry.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<GroupMatchEntry> {
    return GroupMatchEntry.findById(id, filter);
  }

  static async create(
    data: Partial<GroupMatchEntry>,
  ): Promise<GroupMatchEntry> {
    return GroupMatchEntry.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<GroupMatchEntry>,
  ): Promise<GroupMatchEntry> {
    return GroupMatchEntry.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return GroupMatchEntry.deleteById(id);
  }
}

export class GroupMatchEntryFormArray extends PersistedFormArray {
  declare controls: GroupMatchEntryFormGroup[];

  readonly entityName = 'GroupMatchEntry' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(groupMatchEntrySchema, GroupMatchEntry, options);
  }

  protected override createItemGroup() {
    return new GroupMatchEntryFormGroup();
  }

  get array(): GroupMatchEntry[] {
    return this.controls.map((group: GroupMatchEntryFormGroup) => group.object);
  }
}

export class GroupMatchEntryPersistedArray extends PersistedArray<GroupMatchEntry> {
  readonly entityName = 'GroupMatchEntry' as const;

  constructor(options?: PersistedArrayOptions) {
    super(GroupMatchEntry, options);
  }
}
